import { apiSlice } from "../api/apiSlice";

export const leaderboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentMarks: builder.query({
      query: (id) => `/assignmentMark?student_id=${id}&status=published`,
    }),
    getQuizMarks: builder.query({
      query: (id) => `/quizMark?student_id=${id}&status=published`,
    }),
  }),
});

export const { useGetAssignmentMarksQuery, useGetQuizMarksQuery } =
  leaderboardApi;
